import { Vue, Component, Prop } from 'vue-property-decorator'
import { BtnList } from '@/types/common/btn'
import './index.scss'
@Component
export default class extends Vue {
  @Prop() btnList!: []
  @Prop() text!: string

  textElement () {
    return this.text && <div class='new-footer-text'>{this.text}</div>
  }

  btnListElement () {
    return (
      this.btnList?.length &&
      this.btnList.map((item: BtnList) => {
        const { name, type = 'primary', size = 'small', icon = null, disabled = false } = item
        return (
          <el-button
            type={type}
            size={size}
            icon={icon}
            disabled={disabled}
            onClick={() => this.$emit('on-click', item)}
          >
            {name}
          </el-button>
        )
      })
    )
  }

  render () {
    return (
      <div class='new-footer-wrap'>
        {this.textElement()}
        <div class='new-footer-btn-wrap'>{this.btnListElement()}</div>
      </div>
    )
  }
}
